module.exports = __webpack_public_path__ + "static/media/Project Plan.bd9ab436.png";